<template>
  <div class="text-courseware-page">
    <!-- 顶部Banner -->
    <Banner />
    <div class="content-wrapper">
      <div class="left-list">
        <!-- 分类导航 -->
        <nav-filter />
        <!-- 面包屑 -->
        <div class="breadcrumb-bar">
          <button
            class="breadcrumb-back"
            @click="
              $router && $router.back ? $router.back() : window.history.back()
            "
          >
            返回
          </button>
          <span class="breadcrumb-link">万知学习</span>
          <span class="breadcrumb-separator">/</span>
          <span class="breadcrumb-link">{{ guidInfo.belong_cn }}</span>
          <span class="breadcrumb-separator">/</span>
          <span class="breadcrumb-link">{{ guidInfo.schoolname }}</span>
          <span class="breadcrumb-separator">/</span>
          <span class="breadcrumb-current">校园风采列表</span>
        </div>
        <!-- 校园风采卡片列表 -->
        <div class="news-list">
          <div class="news-card" v-for="item in list" :key="item.id" @click="goDetail(item.id)">
            <img class="news-img" :src="picUrl + item.pic" alt="校园风采图片" />
            <div class="news-content">
              <div class="news-title">{{ item.title }}</div>
              <div class="news-time">发布时间：{{ item.inputtime }}</div>
              <div class="news-desc">{{ item.content }}</div>
            </div>
          </div>
          <div v-if="list.length === 0" class="no-data">暂无数据</div>
        </div>
        <!-- 分页 -->
        <el-pagination
          background
          layout="prev, pager, next"
          :total="total"
          :page-size="pageSize"
          :current-page="page"
          @current-change="handlePageChange"
          class="pagination-bar"
        />
      </div>
      <div class="right-news">
        <!-- <ad-sidebar /> -->
        <v-right
          :marketBannerSmall="marketBannerSmall"
          :marTop="false"
        ></v-right>
      </div>
    </div>
  </div>
</template>

<script>
import sign from '@/auth/sign'
import Banner from '@/components/common/Banner.vue'
// import AdSidebar from '@/components/common/AdSidebar'
import vRight from '@/components/education/Right2'
import NavFilter from '@/components/teacher/NavFilter.vue'
import { getschoolNoticeLists, getEduDetails } from '@/axios/education'
import url from '@/axios/url'
export default {
  name: 'TextCourseware',
  components: {
    Banner,
    // AdSidebar,
    vRight,
    NavFilter
  },
  data () {
    return {
      picUrl: url.picUrl,
      list: [],
      page: 1,
      pageSize: 10,
      total: 0,
      school_id: parseInt(this.$route.query.school_id) || '',
      type: 1,
      guidInfo: {
        name: '',
        zhiwu: ''
      }
    }
  },
  computed: {
    marketBannerSmall () {
      return this.$store.getters.travleBanner.sbanner
    }
  },
  created () {
    this.getguidInfo()
    this.getLists()
  },
  methods: {
    goDetail (id) {
      this.$router.push({
        name: 'SchoolLifeInfo',
        query: {
          id,
          type: this.type,
          is_mein: 1
        }
      })
    },
    getguidInfo () {
      const params = {
        appid: 'wzwebapp',
        timestamp: parseInt(new Date().getTime() / 1000),
        id: this.school_id,
        type: 1
      }
      const signO = sign(params)
      params.sign = signO
      getEduDetails(params).then((res) => {
        if (res.data.code === 200) {
          const data = res.data.data
          this.guidInfo = {
            belong_cn: data.belong_cn || '',
            schoolname: data.schoolname || ''
          }
        }
      })
    },
    getLists () {
      const params = {
        appid: 'wzwebapp',
        timestamp: parseInt(new Date().getTime() / 1000),
        school_id: this.school_id,
        stype: 1,
        ntype: 3,
        page: this.page
      }
      const signO = sign(params)
      params.sign = signO
      getschoolNoticeLists(params)
        .then((res) => {
          if (res.data.code === 200) {
            const data = res.data.data
            this.list = data.lists || []
            this.total = data.total || 0
          } else {
            this.list = []
            this.total = 0
          }
        })
        .catch(() => {
          this.list = []
          this.total = 0
        })
    },
    handlePageChange (page) {
      this.page = page
      this.getLists()
    }
  }
}
</script>

<style lang="less" scoped>
.text-courseware-page {
  background: #fff;
  padding-bottom: 20px;
}
.content-wrapper {
  display: flex;
  margin-top: 20px;
  width: 1200px;
  margin-left: auto;
  margin-right: auto;
}
.left-list {
  flex: 1;
  margin-right: 20px;
}
.right-news {
  width: 320px;
}
.breadcrumb-bar {
  display: flex;
  align-items: center;
  background: #f9f9f9;
  border-radius: 6px;
  padding: 8px 18px;
  margin-bottom: 16px;
  font-size: 14px;
}
.breadcrumb-back {
  border: 1px solid #e5e5e5;
  background: #fff;
  color: #888;
  border-radius: 4px;
  padding: 2px 10px;
  margin-right: 16px;
  height: 28px;
  font-size: 13px;
  cursor: pointer;
  transition: background 0.2s, border 0.2s;
  &:hover {
    background: #f2f2f2;
    border-color: #ccc;
  }
}
.breadcrumb-link {
  color: #666;
}
.breadcrumb-separator {
  color: #ccc;
  margin: 0 4px;
}
.breadcrumb-current {
  color: #ef8432;
  font-weight: bold;
}
.pagination-bar {
  text-align: center;
  margin-top: 20px;
}
.no-data {
  text-align: center;
  color: #aaa;
  margin: 30px 0;
}

.news-list {
  display: flex;
  flex-direction: column;
  gap: 24px;
}
.news-card {
  display: flex;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.06);
  padding: 18px;
  align-items: flex-start;
  transition: box-shadow 0.2s;
  cursor: pointer;
  &:hover {
    box-shadow: 0 4px 16px rgba(0,0,0,0.10);
  }
}
.news-img {
  width: 160px;
  height: 160px;
  object-fit: cover;
  margin-right: 20px;
  background: #f2f2f2;
}
.news-content {
  flex: 1;
  display: flex;
  flex-direction: column;
}
.news-title {
  font-size: 18px;
  font-weight: bold;
  color: #222;
  margin-bottom: 8px;
}
.news-time {
  font-size: 13px;
  color: #999;
  margin-bottom: 8px;
}
.news-desc {
  font-size: 15px;
  color: #444;
  line-height: 1.6;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>



// WEBPACK FOOTER //
// src/components/teacher/schoolMien.vue